import { Button, Drawer, Space, Spin } from "antd";
import { AiOutlineClose, AiOutlinePrinter } from "react-icons/ai";
import DocumentWrapper from "./document/DocumentWrapper";
import ReactToPrint from "react-to-print";
import { useEffect, useRef, useState } from "react";
import fetchStatement from "../../../services/fetchStatement";
import splitIntoChunks from "../../../utils/splitIntoChunks";
import NoResults from "../../../components/shared/NoResults";

export default function StatementPannel({
  isVisible,
  setVisible,
  selected,
}: any) {
  const docRef = useRef(null);
  const [isLoading, setLoading] = useState(false);
  const [statements, setStatements] = useState<any>([]);
  const [allTransaction, setTransactions] = useState<any>([]);

  const handleFetchStatements = async () => {
    setLoading(true);
    const data = await fetchStatement(selected.account);
    const chunks = splitIntoChunks(data, 18);
    setTransactions(data);
    setStatements(chunks);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchStatements();
  }, [selected]);

  const getTotalDue = () => {
    let total = 0;

    allTransaction.forEach((item: any) => {
      total = total + item.outstanding;
    });
    return total;
  };

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">Customer Statement</span>
        </div>
      }
      placement={"right"}
      width={900}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button type="default" color="blue">
            <ReactToPrint
              trigger={() => {
                return (
                  <button className="flex justify-center items-center focus:outline-none hover:text-red-500 mr-2">
                    <AiOutlinePrinter className="mr-2" /> Print
                  </button>
                );
              }}
              content={() => docRef.current}
              documentTitle={`Statement`}
            />
          </Button>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="flex flex-row bg-whitish  justify-center items-start overflow-auto">
        <div className="bg-white px-4">
          {isLoading ? (
            <div className="">
              <Spin />
            </div>
          ) : (
            <div className="">
              {statements.length === 0 ? (
                <div className="flex justify-center items-center mt-16">
                  <NoResults />
                </div>
              ) : (
                <div className="book" ref={docRef}>
                  {statements.map((page: any, index: number) => (
                    <div className="page" key={index}>
                      <div className="subpage">
                        <DocumentWrapper
                          statements={page}
                          selected={selected}
                          pageno={index + 1}
                          pages={statements.length}
                          getTotalDue={getTotalDue}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Drawer>
  );
}
